// tslint:disable: component-class-suffix
// tslint:disable: component-selector
// tslint:disable: max-line-length
import { Component, Input } from "@angular/core";

@Component({
    selector: "p-progressSpinner",
    template: `
        <div class="ui-progress-spinner" [ngStyle]="style" [ngClass]="styleClass">
            <svg class="ui-progress-spinner-svg" viewBox="25 25 50 50" [style.animation-duration]="animationDuration">
                <circle class="ui-progress-spinner-circle" cx="50" cy="50" r="20" [attr.fill]="fill" [attr.stroke-width]="strokeWidth" stroke-miterlimit="10"/>
            </svg>
        </div>
    `,
    styleUrls: ["./ng-progressspinner.css"]
})
export class NgProgressSpinner {
    @Input() style: any;
    @Input() styleClass: string;
    @Input() strokeWidth = "2";
    @Input() fill = "none";
    @Input() animationDuration = "2s";
}
